import {SharedIssueBaseStore} from "@shared/components/issues/store/shared-issue-base.reducers";

export const techIssueStore = SharedIssueBaseStore;
